import * as React from "react";
import { Alert } from "components/bootstrap";
const DataLakeBackendWarning = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "Note that for the active backend to be changed, all data must first be deleted from the current backend.");
export default DataLakeBackendWarning;
